/* eslint-disable no-undef */
/* eslint-disable no-undef */
import { userAuthReducer } from "../Actions/Pagos";
import { call, put, delay } from "redux-saga/effects";

export function* FetchingUserInfo() {
  if (process.env.NODE_ENV === "production") {
    //verifica usuario logeado
    yield delay(1000);
    const isAuth = yield call(compTools.estaAutenticado);
    const userInfo = yield call(compTools.obtenerInformacionUsuario);
    yield put(userAuthReducer(isAuth, userInfo)); //ACTION
  }
}
